import { useSetAtom, type WritableAtom } from 'jotai';
import { useCallback } from 'react';

import { currentPageAtom } from '../atoms/inventoryAtoms';
import { clearInventorySelectionAtom } from '../atoms/inventorySelectionAtoms';

/**
 * Custom hook that wraps useSetAtom and automatically resets the page to 1
 * whenever a filter value is updated.
 */
export function useSetFilterAtom<Value>(
	filterAtom: WritableAtom<Value, [Value], void>,
): (value: Value) => void {
	const setFilter = useSetAtom(filterAtom);
	const setPage = useSetAtom(currentPageAtom);
	const clearSelection = useSetAtom(clearInventorySelectionAtom);

	return useCallback(
		(value: Value) => {
			setFilter(value);
			setPage(1);
			clearSelection();
		},
		[setFilter, setPage, clearSelection],
	);
}
